(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('NewCompanyRequestController', NewCompanyRequestController);

        NewCompanyRequestController.$inject = ['$scope', 'GenericService', 'GenericServiceNew', 'CompanyReportService', '$http', '$state', '$uibModal', '$filter'];

    function NewCompanyRequestController($scope, GenericService, GenericServiceNew, CompanyReportService, $http, $state, $uibModal, $filter) {

        $scope.showError = false;
		$scope.newCompanyRequest = {};
		$scope.responseMessage = '';

		$scope.saveNewRequest = function() {
			$scope.responseMessage = '';
			CompanyReportService.requestNewCompany($scope.newCompanyRequest).then(
				function(successData) {
					$scope.isError = false;
					$scope.showError = false;
					$scope.responseMessage = successData.data;
					$scope.newCompanyRequest = {};
				}, function (errorData) {
					$scope.isError = true
					$scope.showError = false;
					$scope.responseMessage = errorData.data;
				 }
			);
		}

		$scope.closeAlert = function() {
			$scope.newCompanyRequest = {};
			$scope.responseMessage = '';
		}
		
    }
})();